export enum AchRefundApiRoutes {
  Transactions = '/carts/:id/ach-refundable-transactions',
  Process = '/carts/:id/manual-refund',
}
